import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router";
import { Table } from "react-bootstrap";
import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ButtonRow from "../common/button/ButtonRow";
import { DeleteButton, PrimaryButton } from "../common/button/Buttons";
import { useLimits } from "../../hooks/useLimits";
import FirebaseService from "../../actions/firebase/FirebaseActions";
import { useAuthentication } from "../../hooks/useAuthentication";
import { ContentLayout } from "../common/Layout";
import { useUserIdParam } from "../../hooks/useUserIdParam";

interface Props {
  isAuthenticated: boolean;
}

const Limits: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const userId = useUserIdParam();

  const [limits, limitsLoading, limitsError] = useLimits(userId);
  useAuthentication(isAuthenticated);

  if (limitsError) return <p>Fehler beim Laden der Daten</p>;
  else {
    return (
      <ContentLayout siteTitle={"Spielgruppe Online - Angebot"} title={"Angebot"} isLoading={limitsLoading}>
        <ButtonRow>
          <PrimaryButton
            className={"m-1"}
            onClick={() => {
              navigate(`/user/${userId}/limits/create`);
            }}>
            Neues Angebot
          </PrimaryButton>
        </ButtonRow>
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>Formularfeld</th>
              <th>Anzahl Plätze gesamt</th>
              <th>Anzahl Plätze belegt</th>
              <th>Preis</th>
              <th>Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {limits.map((limit, index) => {
              return (
                <tr key={index}>
                  <td>{limit.property}</td>
                  <td>{limit.limit}</td>
                  <td>{limit.taken}</td>
                  <td>{limit.price ? `CHF ${limit.price}` : ""}</td>
                  <td>
                    <PrimaryButton
                      className={"m-1"}
                      onClick={() => {
                        navigate(`/user/${userId}/limits/${limit.id}`);
                      }}>
                      <FontAwesomeIcon icon={faPencilAlt} />
                    </PrimaryButton>

                    <DeleteButton
                      className={"m-1"}
                      onClick={() => {
                        if (window.confirm("Limitierung wirklich löschen?")) {
                          FirebaseService.deleteLimit(userId, limit.id);
                        }
                      }}>
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </DeleteButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </ContentLayout>
    );
  }
};

export default Limits;
